<style lang="less">
.signUp,
.signUpM {
  width: 275px;
  margin: auto;
  text-align: left;
  padding-top: 4px;

  .formMessage {
    .inputLi {
      height: 37px;
      line-height: 37px;
      border-bottom: 1px solid #d5d6d6;
      margin-bottom: 24px;
      position: relative;

      input {
        border: 0;
        outline: none;
        font-size: 16px;
        width: 152px;
        height: 36px;
        color: #000;
      }
    }

    .phoneNum {
      position: relative;

      .areaInput {
        width: 90px;
        color: #009265;
        cursor: pointer;
      }

      .optionList {
        position: absolute;
        overflow-y: auto;
        width: 200px;
        height: 300px;
        background: #fff;
        border: 1px solid #d5d6d6;
        border-top: none;
        font-size: 14px;
        z-index: 999999999;

        li {
          line-height: 2;
          padding-right: 6px;
        }
      }

      .arrowDown {
        position: absolute;
        width: 0;
        height: 0;
        border-right: 4.5px solid transparent;
        border-left: 4.5px solid transparent;
        border-top: 6px solid #a0a2aa;
        margin-top: 15px;
        margin-left: -25px;
      }

      .number2 {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .countryCode {
      display: inline-block;
    }

    .picCode {
      img {
        position: absolute;
        width: 103px;
        height: 35px;
        cursor: pointer;
        right: 0;
        bottom: 2px;
      }
    }

    .msgCode {
      .sendCode {
        width: 54px;
        height: 20px;
        line-height: 20px;
        color: #009265;
        font-size: 14px;
        text-align: right;
        position: absolute;
        right: 0;
        bottom: 9px;
        cursor: pointer;
      }

      .sendMsgInfo {
        color: #98cbbb;
        cursor: default;
      }
    }

    .isRegister {
      input {
        width: 100%;
        padding-right: 44px;
      }

      img {
        position: absolute;
        width: 18px;
        color: #9b9b9b;
        top: 8px;
        right: 8px;
      }
    }
  }

  .errorMsg {
    position: absolute;
    font-size: 12px;
    color: #ff5741;
    left: 0;
    top: 39px;
    line-height: 1.2;
  }

  .userAgreement {
    font-size: 14px;
    position: relative;
    margin-top: 36px;

    .userAgreementCheck {
      font-size: 13px;
      color: #009265;
      cursor: pointer;
      margin-right: 5px;
    }

    .is-link {
      color: #009265;
    }
  }
}

.signUp {
  .formMessage {
    .phoneNum {
      .number {
        width: 185px;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .number2 {
        width: 100%;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

.signUpM {
  width: 550px;
  padding-top: 8px;

  .formMessage {
    .inputLi {
      height: 74px;
      line-height: 74px;
      margin-bottom: 48px;

      input {
        font-size: 32px;
        width: 304px;
        height: 72px;
      }
    }

    .phoneNum {
      .areaInput {
        width: 180px;
      }

      .optionList {
        width: 400px;
        height: 480px;
        font-size: 28px;

        li {
          padding-right: 12px;
        }
      }

      .arrowDown {
        border-right: 9px solid transparent;
        border-left: 9px solid transparent;
        border-top: 12px solid #a0a2aa;
        margin-top: 30px;
        margin-left: -50px;
      }

      .number {
        width: 370px;
        font-size: 32px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .picCode {
      img {
        width: 206px;
        height: 70px;
        bottom: 4px;
      }
    }

    .msgCode {
      .sendCode {
        width: 108px;
        height: 40px;
        line-height: 40px;
        font-size: 28px;
        bottom: 18px;
      }
    }

    .isRegister {
      input {
        width: 100%;
        padding-right: 88px;
      }

      img {
        width: 36px;
        margin-top: 7px;
        right: 16px;
      }
    }
  }

  .errorMsg {
    font-size: 24px;
    top: 78px;
  }

  .userAgreement {
    font-size: 28px;
    margin-top: 72px;

    .userAgreementCheck {
      font-size: 26px;
      margin-right: 10px;
    }
  }
}

#captchaEle.isIOS {
  width: 300px;
  height: 65px;
  position: relative;
  left: 150px;
  top: 40px;
  iframe {
    transform: scale(2);
    top: 0;
    left: 0;
    position: absolute;
  }
}
#captchaEle{
  iframe{
    width: 95% !important;
  }
}
</style>
<template>
  <div :class="isMobile ? 'signUpM' : 'signUp'">
    <ul class="formMessage eeo-ul">
      <li class="inputLi phoneNum">
        <section class="countryCode" v-if="!isEmail">
          <input type="text" readonly="readonly" @click.stop="showOptionList" v-model="form.selectAreaShow"
            class="areaInput" />
          <span class="arrowDown"></span>
          <ul class="eeo-ul optionList" v-show="optionList" ref="optionList">
            <li v-for="(item, index) in phoneAreaNumList" :key="index" @click="selectAreaCode(item)"
              :style="{ background: item.show == form.selectAreaShow ? '#ddd' : '' }">
              {{ item.label }}
            </li>
          </ul>
        </section>

        <!-- 手机号输入框 -->
        <input v-if="!isEmail" class="number" type="text" :value="form.phoneNumber" @input="inputHandle"
          @blur="phoneNumbervalidate(form.phoneNumber)" :placeholder="$t('publesson.placeholder.phoneNumber')" />

        <!-- 邮箱输入框 -->
        <input v-else class="number2" type="text" :value="form.email" @input="inputHandle" @blur="emailValidate"
          :placeholder="$t('publesson.placeholder.phoneNumber')" :maxlength="50" />
        <!-- 出错提示 -->
        <span v-if="rules.phoneNumber && !isEmail" class="errorMsg">
          {{ errorMsg.phoneNumber }}
        </span>
        <span v-else-if="rules.email && isEmail" class="errorMsg">
          {{ errorMsg.email }}
        </span>
        <span v-else-if="firstError" class="errorMsg">
          {{ $t('publesson.errorMsg.firstError') }}
        </span>
      </li>

      <!-- <li class="inputLi picCode">
        <input
          type="text"
          v-model="form.picCode"
          :placeholder="$t('publesson.placeholder.verCode')"
          @blur="picCodevalidate(form.picCode)"/>
        <img :src="form.codeSrc" @click="changePicCode">
        <span v-if="rules.picCode" class="errorMsg">
          {{errorMsg.picCode}}
        </span>
      </li> -->
      <li class="inputLi msgCode">
        <input type="text" v-model="form.msgCode" :placeholder="$t('publesson.placeholder.verCode')"
          @blur="msgCodevalidate(form.msgCode)" autocomplete="off" maxlength="4" style="
            -webkit-appearance: none;
            -webkit-box-shadow: 0 0 0 1000px white inset !important;
            background-color: rgb(255, 255, 255);
            outline: none;
            border: 0;
          " />
        <span class="sendCode" @click="sendMsgCode" :class="{ sendMsgInfo: sendMsgInfo.isSending }">
          {{ sendMsgInfo.btnTxt }}
        </span>
        <span v-if="rules.msgCode" class="errorMsg">
          {{ errorMsg.msgCode }}
        </span>
      </li>
      <!-- 未注册账号输入密码 -->
      <li v-if="!registerConfig.isRegister" class="inputLi">
        <input type="text" v-model="form.nickName" autocomplete="off" :placeholder="$t('publesson.placeholder.nickName')"
          @blur="namevalidate(form.nickName)" style="
            width: 100%;
            -webkit-appearance: none;
            -webkit-box-shadow: 0 0 0 1000px white inset !important;
            background-color: rgb(255, 255, 255);
            outline: none;
            border: 0;
          " />
        <span v-if="rules.nickName" class="errorMsg">
          {{ errorMsg.nickName }}
        </span>
      </li>
      <li v-if="!registerConfig.isRegister" class="inputLi isRegister">
        <input :type="registerConfig.inputType" v-model="form.password" autocomplete="off"
          :placeholder="$t('publesson.placeholder.password')" @blur="pwdCodevalidate(form.password)" />
        <img :src="registerConfig.pwdIcon" @mousedown="isShowPwd(true)" @touchstart="isShowPwd(true)"
          @mouseup="isShowPwd(false)" @touchend="isShowPwd(false)" @mouseleave="isShowPwd(false)" style="
            -webkit-appearance: none;
            -webkit-box-shadow: 0 0 0 1000px white inset !important;
            background-color: rgb(255, 255, 255);
            outline: none;
            border: 0;
          " />
        <span v-if="rules.password" class="errorMsg">
          {{ errorMsg.password }}
        </span>
      </li>
    </ul>
    <div class="userAgreement">
      <span class="userAgreementCheck" @click="isAgreeUserAgreement"
        :class="[form.agreeUserAgreement ? 'el-icon-checkbox' : 'el-icon-checkbox_noselect']"></span>
      <span v-html="$t('publesson.readUserAgm')"></span>
    </div>
    
    <div id="captchaEle" :class="isIOS ? 'isIOS' : ''"></div>

    <button class="submitBtn" @click="submit" :style="{
      background: !form.agreeUserAgreement ? '#98ddbc' : '',
      marginBottom: isMobile ? '154px' : '77px',
    }">
      {{ $t('publesson.apply') }}
    </button>
  </div>
</template>

<script>
import restful_publesson from '@/api/publesson/restful_publesson.js'
import { CHINA_PHONE, ENV_TYPE } from '@/constant/index'
import { isAndroidTablet } from '@/utils/common'
import captchaApi from '@classin/captcha-api'

export default {
  props: ['config'],
  filters: {},
  components: {},
  data() {
    return {
      isMobile: window.browserVersion.mobile,
      isIOS: window.browserVersion.ipad || window.browserVersion.iphone || window.browserVersion.ios || isAndroidTablet(),
      clientName: '',
      phoneAreaNumList: [],
      lang: this.$root.globalData.localeLangType,
      // 是否是邮箱登录
      isEmail: false,
      form: {
        selectAreaShow: this.$root.globalData.localeLangType == 'zh-CN' ? '+86' : '+1',
        selectArea: this.$root.globalData.localeLangType == 'zh-CN' ? '0086' : '001',
        phoneNumber: '',
        email: '',
        nickName: '',
        // picCode:'',
        // 验证码
        msgCode: '',
        password: '',
        codeSrc: '//' + window.EEOENV.hosts.dynamic + '/import/captcha/captcha.php',
        // 是否已阅读和同意用户协议
        agreeUserAgreement: false,
      },
      rules: {
        phoneNumber: false,
        nickName: false,
        // picCode:false,
        msgCode: false,
        password: false,
        email: false,
      },
      registerConfig: {
        isRegister: true,
        pwdIcon: require('@/assets/images/k/icon_passwordview_hide.png'),
        inputType: 'password',
      },
      errorMsg: {
        phoneNumber: this.$t('publesson.errorMsg.enterPhoneNumber'),
        email: this.$t('publesson.errorMsg.email_tips'),
        nickName: this.$t('publesson.errorMsg.enterName'),
        // picCode:this.$t('publesson.errorMsg.enterVerCode'),
        msgCode: this.$t('publesson.errorMsg.enterVerCode'),
        password: this.$t('publesson.placeholder.password'),
      },
      sendMsgInfo: {
        isSending: false,
        countDown: 60,
        btnTxt: this.$t('publesson.form.sendMsg'),
      },
      disabled: false,
      optionList: false,
      timer: '',
    }
  },
  computed: {
    firstError() {
      return !this.registerConfig.isRegister && this.form.phoneNumber.startsWith('0')
    },
  },
  methods: {
    // 监听input事件
    inputHandle(e) {
      let value = e.target.value
      value = value.replace(/(^\s*)|(\s*$)/g, '')
      console.log('input', value, value.length)
      // 验证邮箱格式
      const reg = /[(a-zA-z)|@|(.com)]/

      // 邮箱
      if (reg.test(value)) {
        this.form.email = value
        value.length > 50 && (this.form.email = value.slice(0, 50))
        this.isEmail = true
      }
      // 手机号
      else {
        this.form.phoneNumber = value
        this.isEmail = false
      }
    },
    closeOptionList() {
      this.optionList = false
    },
    showOptionList() {
      this.optionList = !this.optionList
      this.$nextTick(() => {
        if (this.form.selectAreaShow == '+86') {
          this.$refs.optionList.scrollTop = this.$refs.optionList.scrollHeight
        }
        if (this.form.selectAreaShow == '+1') {
          this.$refs.optionList.scrollTop = this.$refs.optionList.scrollHeight - 400
        }
      })
    },
    selectAreaCode(item) {
      this.form.selectAreaShow = item.show
      this.form.selectArea = item.value
      if (!(this.form.phoneNumber == '')) {
        this.phoneNumbervalidate(this.form.phoneNumber)
      }
    },
    async sendMsgCode() {
      // 手机号验证 + 手机号不存在
      if (!this.isEmail && !this.form.phoneNumber) {
        this.errorMsg.phoneNumber = this.$t('publesson.errorMsg.enterPhoneNumber')
        this.rules.phoneNumber = true
        return
      }

      // 邮箱验证 + 邮箱不存在
      if (this.isEmail && !this.form.email) {
        this.errorMsg.email = this.$t('publesson.errorMsg.email_Error')
        this.rules.email = true
        return
      }

      const curRules = this.isEmail ? this.rules.email : this.rules.phoneNumber
      const visiable = this.sendMsgInfo.isSending || curRules

      // if(!this.form.picCode){
      //   this.errorMsg.picCode=this.$t('publesson.errorMsg.enterVerCode');
      //   this.rules.picCode=true
      // }
      if (!visiable) {
        this.rules.msgCode = false
        let fullPhone = this.form.selectArea === CHINA_PHONE ? this.form.phoneNumber : `${this.form.selectArea}-${this.form.phoneNumber}`
        console.log('===fullPhone====', fullPhone)
        // 验证
        const { open, getCapType } = await captchaApi.init({
          account: this.isEmail ? this.form.email : fullPhone,
          element: "#captchaEle",
          origin: 'https://' + window.EEOENV.hosts.api,
          mode: ENV_TYPE[window.EEOENV.hosts.dynamic] || captchaApi.EEO_CAP_MODE.prod,
          on: {
            [captchaApi.EEO_CAP_EVENT_TYPE.success]: (vToken) => {
              const vType = getCapType();
              console.log("success-token-type", vToken, vType);
              this.sendCodeAxios(vToken, vType);
              setTimeout(() => {
                close();
              }, 1000);
            },
            [captchaApi.EEO_CAP_EVENT_TYPE.fail]: (data) => {
              console.error("auto verify error", data);
              setTimeout(() => {
                close();
              }, 1000);
            },
          },
        });
        const { close } = open();

        /* window.eeoTcaptcha(
          fullPhone,
          (captcha) => {
            this.sendCodeAxios(captcha)
          },
          (err) => {
            console.log(err)
          }
        ) */
      }
    },
    sendCodeAxios(vToken, vType) {
      var postData = {
        selectArea: !this.isEmail ? this.form.selectArea : '',
        mobile: !this.isEmail ? this.form.phoneNumber : '',
        // 说明：1:手机号 2:邮箱
        type: this.isEmail ? 2 : 1,
        email: this.isEmail ? this.form.email : '',
        vToken,
        vType,
        // phoneNumber: this.form.phoneNumber,
        // captcha,
        // ticket: obj.ticket,
        // randStr: obj.randstr
      }
      restful_publesson('sendCode', postData).then((res) => {
        var resData = res.data
        //this.changePicCode();
        if (typeof resData == 'boolean') {
          this.registerConfig.isRegister = resData
          this.sendMsgInfo.isSending = true
          this.sendMsgInfo.countDown = 60
          this.timer = setInterval(() => {
            this.sendMsgInfo.countDown--
            this.sendMsgInfo.btnTxt = this.$t('publesson.form.reSend', { num: this.sendMsgInfo.countDown })
            if (this.sendMsgInfo.countDown < 1) {
              this.sendMsgInfo.btnTxt = this.$t('publesson.form.sendMsg')
              clearInterval(this.timer)
              this.sendMsgInfo.isSending = false
            }
          }, 1000)
        } else {
          switch (resData) {
            case 104:
              this.errorMsg.msgCode = this.$t('publesson.errorMsg.operateFail')
              this.rules.msgCode = true
              break
            case 108:
              this.errorMsg.msgCode = this.$t('publesson.errorMsg.sendLimit')
              this.rules.msgCode = true
              break
            case 109:
              this.errorMsg.msgCode = this.$t('publesson.errorMsg.sendfrequently')
              this.rules.msgCode = true
              break
            case 110:
              this.errorMsg.msgCode = this.$t('publesson.errorMsg.sendFail')
              this.rules.msgCode = true
              break
            case 134:
              this.errorMsg.phoneNumber = this.$t('publesson.errorMsg.phoneIllegal')
              this.rules.phoneNumber = true
              break

            // NEW:
            case 100:
            case 101:
            case 102:
            case 113:
            case 133:
            case 135:
            case 136:
            case 166:
            case 20704:
            case 20718:
            case 20727:
            case 20728:
            case 20729:
            case 20730:
            case 20731:
            case 20732:
            case 20733:
            case 20734:
              window.vant.Dialog.alert({
                message: this.$t(`publesson.errorMsg.${resData}`),
                confirmButtonText: 'OK',
                confirmButtonColor: '#30ba78',
              })
            // case 346:
            //   this.errorMsg.picCode=this.$t('publesson.errorMsg.wrongVerCode');
            //   this.rules.picCode=true;
            //   break;
          }
        }
      })
    },
    checkForm() {
      for (var key in this.form) {
        if (this.form[key] === '') {
          this.rules[key] = true
          if (this.registerConfig.isRegister) {
            this.rules.nickName = false
            this.rules.password = false
          }
        }
      }
    },

    // 自助添加公开课学生
    addStudent(postData) {
      if (this.firstError) return
      var postData = {
        classId: this.config.lessonId,
        selectArea: !this.isEmail ? this.form.selectArea : '',
        mobile: !this.isEmail ? this.form.phoneNumber : '',
        identifyCode: this.form.msgCode,
        email: this.isEmail ? this.form.email : '',
        // 名称
        name: this.form.nickName,
      }
      console.log('===addStudent===', postData)
      this.form.nickName && (postData.nickName = this.form.nickName)
      restful_publesson('addlessonStu', postData).then((res) => {
        this.$root.loading = false
        var resData = res.data
        if (typeof resData == 'string') {
          // this.changePicCode();
        } else {
          switch (resData) {
            case 1:
              this.$emit('signUp', 'signUpSuccess')
              break
            case 111:
              this.errorMsg.msgCode = this.$t('publesson.errorMsg.wrongVerCode')
              this.rules.msgCode = true
              break
            // 账号未注册
            case 113:
              this.registerConfig.isRegister = false
              break
            case 128:
              window.meaasgeAlert(this.$t('publesson.tip.noAddStu'))
              break
            case 129:
              window.meaasgeAlert(this.$t('publesson.tip.teacher'))
              break
            case 157:
              this.$emit('signUp', 'lessonStuFull')
              break
            // 加入成功
            case 166:
              this.$emit('signUp', 'signUpSuccess')
              break
            case 212:
              this.$emit('routerTo', 'tipPage')
              break
            case 304:
              window.meaasgeAlert(this.$t('publesson.tip.institutionDisabled'))
              break
            case 329:
              window.meaasgeAlert(this.$t('publesson.tip.assistant'))
              break
          }
        }
      })
    },

    // 注册的错误码处理
    userRegisterErrorCodeHandle(resData, className) {
      switch (resData) {
        case 1:
          this.addStudent()
          break
        case 111:
          this.errorMsg.msgCode = this.$t('publesson.errorMsg.wrongVerCode')
          this.rules.msgCode = true
          this.$root.loading = false
          break
        case 1040:
          window.meaasgeAlert(this.$t('publesson.errorMsg.pwdHasNumEn'))
          window.AppRoot.loading = false
          // window.vant.Dialog.alert({
          //   message: this.$t('publesson.errorMsg.pwdHasNumEn'),
          //   confirmButtonText: 'OK',
          //   confirmButtonColor: '#30ba78',
          //   className: className,
          // }).then(() => {
          //   window.AppRoot.loading = false
          // })
          break
        case 1041:
          window.meaasgeAlert(this.$t('publesson.errorMsg.pwdIllegal'))
          window.AppRoot.loading = false
          // window.vant.Dialog.alert({
          //   message: this.$t('publesson.errorMsg.pwdIllegal'),
          //   confirmButtonText: 'OK',
          //   confirmButtonColor: '#30ba78',
          //   className: className,
          // }).then(() => {
          //   window.AppRoot.loading = false
          // })
          break
        case 1042:
          window.meaasgeAlert(this.$t('publesson.errorMsg.pwdHasCn'))
          window.AppRoot.loading = false
          // window.vant.Dialog.alert({
          //   message: this.$t('publesson.errorMsg.pwdHasCn'),
          //   confirmButtonText: 'OK',
          //   confirmButtonColor: '#30ba78',
          //   className: className,
          // }).then(() => {
          //   window.AppRoot.loading = false
          // })
          break
        case 1043:
          window.meaasgeAlert(this.$t('publesson.errorMsg.pwdHasEmpty'))
          window.AppRoot.loading = false
          // window.vant.Dialog.alert({
          //   message: this.$t('publesson.errorMsg.pwdHasEmpty'),
          //   confirmButtonText: 'OK',
          //   confirmButtonColor: '#30ba78',
          //   className: className,
          // }).then(() => {
          //   window.AppRoot.loading = false
          // })
          break
        case 1008:
          window.meaasgeAlert(this.$t('publesson.errorMsg.apiOverrun'))
          window.AppRoot.loading = false
          // window.vant.Dialog.alert({
          //   message: this.$t('publesson.errorMsg.apiOverrun'),
          //   confirmButtonText: 'OK',
          //   confirmButtonColor: '#30ba78',
          //   className: className,
          // }).then(() => {
          //   window.AppRoot.loading = false
          // })
          break
        // NEW:
        case 100:
        case 101:
        case 102:
        case 108:
        case 109:
        case 110:
        case 113:
        case 133:
        case 134:
        case 135:
        case 136:
        case 166:
        case 20704:
        case 20718:
        case 20727:
        case 20728:
        case 20729:
        case 20730:
        case 20731:
        case 20732:
        case 20733:
        case 20734:
          window.meaasgeAlert(this.$t(`publesson.errorMsg.${resData}`))
          window.AppRoot.loading = false
        // window.vant.Dialog.alert({
        //   message: this.$t(`publesson.errorMsg.${resData}`),
        //   confirmButtonText: 'OK',
        //   confirmButtonColor: '#30ba78',
        //   className: className,
        // }).then(() => {
        //   window.AppRoot.loading = false
        // })
      }
    },

    // 用户注册
    userRegister() {
      var postData = {
        selectArea: !this.isEmail ? this.form.selectArea : '',

        // phoneNumber: this.form.phoneNumber,
        mobile: !this.isEmail ? this.form.phoneNumber : '',

        email: this.isEmail ? this.form.email : '',
        nickName: this.form.nickName,

        // msgCode: this.form.msgCode,
        verificationCode: this.form.msgCode,
        password: this.form.password,
        // integer 说明：是否设置cookie 默认为设置cookie 不想设置传0
        isLogin: 0,
      }

      restful_publesson('userRegister', postData).then((res) => {
        var resData = res.data
        let className = 'vant_dialog'
        if (window.browserVersion.mobile) {
          className = 'vant_dialog_m'
        }
        console.log('===resData===', resData)
        this.userRegisterErrorCodeHandle(resData, className)
      })
    },

    // 报名按钮点击
    submit() {
      if (this.form.agreeUserAgreement) {
        this.checkForm()
        var verify = true
        for (var key in this.rules) {
          // 邮箱登录
          if (this.isEmail && key !== 'phoneNumber' && this.rules[key]) {
            verify = false
          }

          // 手机号登录
          if (!this.isEmail && key !== 'email' && this.rules[key]) {
            verify = false
          }
        }
        if (verify) {
          this.$root.loading = true
          if (!this.registerConfig.isRegister) {
            this.userRegister()
          } else {
            this.addStudent()
          }
        }
      }
    },
    isAgreeUserAgreement() {
      this.rules.userAgreement = this.form.agreeUserAgreement
      this.form.agreeUserAgreement = !this.form.agreeUserAgreement
    },
    getPhoneArea() {
      window.requireJs(['/assets/data/js/arealocation20210802/phoneareanum_sortby_' + this.lang + '.js'], (data) => {
        data.map((v, i) => {
          var list = {
            show: '+' + v.num,
            value: '00' + v.num,
            label: '+' + v.num + '(' + v.name[this.lang === 'zh-CN' ? 'cn' : 'en'] + ')',
          }
          this.phoneAreaNumList.push(list)
        })
      })
    },
    // TODO:
    checkUserRegister() {
      var telephone = this.form.selectArea == '0086' ? this.form.phoneNumber : this.form.selectArea + '-' + this.form.phoneNumber
      restful_publesson('check', {
        mobile: telephone,
        verificationCode: this.form.msgCode,
        // picCode: this.form.picCode
      }).then((res) => {
        var resData = res.data
        if (typeof resData == 'number') {
          switch (resData) {
            case 104:
              this.errorMsg.phoneNumber = this.$t('publesson.errorMsg.operateFail')
              this.rules.phoneNumber = true
              break
            case 134:
              this.errorMsg.phoneNumber = this.$t('publesson.errorMsg.phoneIllegal')
              this.rules.phoneNumber = true
              break
          }
        } else {
          this.registerConfig.isRegister = resData
        }
      })
    },
    phoneNumbervalidate(value) {
      if (this.isEmail) return
      this.rules.phoneNumber = false
      this.errorMsg.phoneNumber = ''
      value = value.replace(/(^\s*)|(\s*$)/g, '')
      if (value === '') {
        this.errorMsg.phoneNumber = this.$t('publesson.errorMsg.enterPhoneNumber')
        this.rules.phoneNumber = true
        return false
      } else {
        if (this.form.selectArea === '0086' && value.length != 11) {
          this.errorMsg.phoneNumber = this.$t('publesson.errorMsg.enterTruePhoneNumber')
          this.rules.phoneNumber = true
          return false
        } else if (parseInt(value) != value) {
          this.errorMsg.phoneNumber = this.$t('publesson.errorMsg.enterTruePhoneNumber')
          this.rules.phoneNumber = true
          return false
        }
      }
    },

    // 邮箱验证
    emailValidate() {
      const reg = /^\w+([+-.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      const email = this.form.email
      if (!reg.test(email) || email.length > 50) {
        this.errorMsg.email = this.$t('publesson.errorMsg.email_Error')
        this.rules.email = true
      } else {
        this.rules.email = false
      }
    },

    namevalidate(value) {
      this.rules.nickName = false
      this.errorMsg.nickName = ''
      value = value.replace(/(^\s*)|(\s*$)/g, '')
      if (value === '') {
        this.errorMsg.nickName = this.$t('publesson.errorMsg.enterName')
        this.rules.nickName = true
        return false
      } else {
        let valueLen = value.length
        if (valueLen < 2 || valueLen > 24) {
          this.errorMsg.nickName = this.$t('publesson.errorMsg.enterNameRule')
          this.rules.nickName = true
          return false
        }
      }
    },
    // picCodevalidate(value){
    //   this.rules.picCode=false;
    //   this.errorMsg.picCode='';
    //   value = value.replace(/(^\s*)|(\s*$)/g, "");
    //   if(value===''){
    //     this.errorMsg.picCode=this.$t('publesson.errorMsg.enterVerCode');
    //     this.rules.picCode=true;
    //     return false
    //   }
    // },
    msgCodevalidate(value) {
      this.rules.msgCode = false
      this.errorMsg.msgCode = ''
      value = value.replace(/(^\s*)|(\s*$)/g, '')
      if (value === '') {
        this.errorMsg.msgCode = this.$t('publesson.errorMsg.enterVerCode')
        this.rules.msgCode = true
        return false
      }
    },
    pwdCodevalidate(value) {
      this.errorMsg.password = ''
      this.rules.password = false
      // value = value.replace(/(^\s*)|(\s*$)/g, "");
      if (value === '') {
        this.errorMsg.password = this.$t('publesson.errorMsg.enter6To20Pwd')
        this.rules.password = true
        return false
      } else {
        let flag_zh = /[\u4e00-\u9fa5]+/.test(value),
          flag_en_num = /(?=.*\d)(?=.*[a-zA-Z])/.test(value),
          flag_illegal = /[^a-zA-Z\d~`!@#$%^&*()-+_[{}\\|;:'",.<>/?=\]\u4e00-\u9fa5\s]/.test(value),
          flag_empty = /\s/.test(value)
        if (value.length < 6 || value.length > 20) {
          this.errorMsg.password = this.$t('publesson.errorMsg.enter6To20Pwd')
          this.rules.password = true
          return false
        } else if (!flag_en_num) {
          this.errorMsg.password = this.$t('publesson.errorMsg.pwdHasNumEn')
          this.rules.password = true
          return false
        } else if (flag_illegal) {
          this.errorMsg.password = this.$t('publesson.errorMsg.pwdIllegal')
          this.rules.password = true
          return false
        } else if (flag_zh) {
          this.errorMsg.password = this.$t('publesson.errorMsg.pwdHasCn')
          this.rules.password = true
          return false
        } else if (flag_empty) {
          this.errorMsg.password = this.$t('publesson.errorMsg.pwdHasEmpty')
          this.rules.password = true
          return false
        }
      }
    },
    isShowPwd(status) {
      this.registerConfig.pwdIcon = status
        ? require('@/assets/images/k/icon_passwordview_show.png')
        : require('@/assets/images/k/icon_passwordview_hide.png')
      this.registerConfig.inputType = status ? 'text' : 'password'
    },
    changePicCode() {
      this.form.codeSrc = '//' + window.EEOENV.hosts.dynamic + '/import/captcha/captcha.php?ts=' + new Date().valueOf()
    },
  },
  created() {
    this.getPhoneArea()
  },
  mounted() {
    this.clientName = this.$root.clientName
  },
}
</script>
